import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Route, Switch, Link } from 'react-router-dom';
import { Icon, Menu, Segment, Sidebar } from 'semantic-ui-react';
import { AutoSizer } from 'react-virtualized';
import { visibilityActions } from '../../store/actions/visibility';
import { authenticationActions } from '../../store/actions/authentication';
import * as ROUTES from '../../routes';
import * as Views from './';

import DashboardView from './dashboard/DashboardView';
import BalanceView from './BalanceView';
import ReservationsView from './reservations/ReservationsView';
import NewReservationView from './reservations/NewReservationView';
import AddFundsView from './AddFundsView';

import Authorize from '../Authorize';
import NavigationBar from '../navigation/NavigationBar';
import Footer from '../navigation/Footer';
import ConnectServices from '../../providers/ConnectServices';
import FeathersService from '../../services/FeathersService';

import PasswordDisplayCoupon from './PasswordDisplayCoupon';
import ChangePasswordView from './ChangePasswordView';

const AUAutoSizer = Authorize(AutoSizer, undefined, true);
const AUDashboard = Authorize(DashboardView, ['client']);
const AUReservations = Authorize(ReservationsView, ['client']);
const AUBalance = Authorize(BalanceView, ['client']);
const AUNewReservationView = Authorize(NewReservationView, ['client']);
const AUAddFundsView = Authorize(AddFundsView, ['client']);

class RootView extends Component {

  constructor (props) {
    super(props);

    this.state = {

    };
  }

  signOut = () => {
    FeathersService.logout()
      .then(r => {
        this.props.logOut();
        this.props.toggleNavigationSidebar();
        this.props.navigate(ROUTES.SIGNIN);
      })
      .catch(e => {
        // console.error("issue logging out", e);
      });
  };

  componentWillMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication,
      visibility: state.visibility
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => dispatch(push(path)),
      logOut: () => dispatch(authenticationActions.userAuthenticationLogout()),
      toggleNavigationSidebar: () => dispatch(visibilityActions.toggleNavigationSidebar())
    };
  }

  render () {
    let {
      visibility
    } = this.props;

    const RouterSwitch = (
      <Switch>
        <Route exact path={ROUTES.ROOT} component={Views.WelcomeView} />

        <Route exact path={ROUTES.SIGNIN} component={ConnectServices(Views.SignInView)} />
        <Route exact path={ROUTES.PROFILE} component={ConnectServices(Views.ProfileView)} />
        <Route exact path={ROUTES.RECOVERY} component={ConnectServices(Views.RecoverPasswordView)} />
        <Route exact path={ROUTES.VERIFY} component={ConnectServices(Views.VerificationView)} />

        <Route exact path={ROUTES.DASHBOARD} component={ConnectServices(AUDashboard)} />
        <Route exact path={ROUTES.PAYMENT_STATE} component={ConnectServices(Views.PaymentStateView)} />

        <Route exact path={ROUTES.BALANCE} component={ConnectServices(AUBalance)} />
        <Route exact path={ROUTES.BALANCE_ADD_FUNDS} component={ConnectServices(AUAddFundsView)} />

        <Route exact path={ROUTES.RESERVATIONS} component={ConnectServices(AUReservations)} />
        <Route exact path={ROUTES.RESERVATION_DETAIL} component={Views.ReservationDetailView} />
        <Route exact path={ROUTES.RESERVATION_NEW} component={AUNewReservationView} />

        <Route exact path={ROUTES.ADMIN} component={ConnectServices(Views.AdminView)} />
        <Route exact path={ROUTES.ADMIN_USERS} component={ConnectServices(Views.UsersView)} />

        <Route exact path={ROUTES.PASSWORD_COUPON} component={PasswordDisplayCoupon} />
        <Route exact path={ROUTES.CHANGE_PASSWORD} component={ConnectServices(ChangePasswordView)} />
        <Route exact path={ROUTES.CHANGE_PASSWORD_PREFILLED} component={ConnectServices(ChangePasswordView)} />

        <Route component={Views.NotFoundView} />
      </Switch>
    );

    return (
      <AUAutoSizer disableHeight>
        {({ width }) => {
          if (width > 764) {
            return (
              <div style={{ width , display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
                <NavigationBar />
                <div style={{ display: 'flex', flex: '1' }}>
                  {RouterSwitch}
                </div>
                <Footer />
              </div>
            );
          } else {
            return (
              <div style={{ width, display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
                <Sidebar.Pushable as={Segment}>
                  <Sidebar as={Menu} animation="overlay" width="thin" visible={visibility.get('navigationSidebar')} icon="labeled" vertical inverted>
                    <Menu.Item name="home"  as={Link} to={`/`}> 
                      <Icon name="home" />
                      Home
                    </Menu.Item>
                    <Menu.Item name="list"  as={Link} to={`/reservations`}>
                      <Icon name="list" />
                      Reservas
                    </Menu.Item>
                    <Menu.Item name="dollar" as={Link} to={`/balance`}>
                      <Icon name="dollar" />
                      Saldo
                    </Menu.Item>
                    <Menu.Item name="user" as={Link} to={`/profile`}>
                      <Icon name="user" />
                      Perfil
                    </Menu.Item>
                    <Menu.Item name="Cerrar Sesion" onClick={this.signOut}>
                      <Icon name="log out" />
                      Cerrar Sesion
                    </Menu.Item>
                  </Sidebar>
                  <Sidebar.Pusher style={{ width, display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
                    <NavigationBar mobile />
                    <div style={{ display: 'flex', flex: '1' }}>
                      {RouterSwitch}
                    </div>
                  </Sidebar.Pusher>
                </Sidebar.Pushable>
              </div>
            );
          }
        }}
      </AUAutoSizer>
    );
  }

}

export default connect(RootView.mapStateToProps, RootView.mapDispatchToProps)(RootView);



// WEBPACK FOOTER //
// ./src/components/views/RootView.jsx